// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3ZtFI","Inner":"Header_Inner__1IG93","DescTopOnly":"Header_DescTopOnly__3LQxt"};